import {Mapper} from '@s-ui/domain'

export default class LastSearchesDataToSearchesListValueObjectMapper extends Mapper {
  constructor({searchesListValueObjectFactory, searchItemJsonToSearchItemValueObjectMapper}) {
    super({
      searchesListValueObjectFactory,
      searchItemJsonToSearchItemValueObjectMapper
    })
    this._searchesListValueObjectFactory = searchesListValueObjectFactory
    this._searchItemJsonToSearchItemValueObjectMapper = searchItemJsonToSearchItemValueObjectMapper
  }

  /**
   * @param {String} data
   */
  map = ({items} = {items: []}) => {
    const searchesListItemsPromises = items.map(this._searchItemJsonToSearchItemValueObjectMapper.map)

    return Promise.all(searchesListItemsPromises).then(searchesListItems =>
      this._searchesListValueObjectFactory({items: searchesListItems.reverse()})
    )
  }
}
